// extracted by mini-css-extract-plugin
export default {"markWrapper":"GoogleAnalyticsLogo_markWrapper__Rv8xW","lockupWrapper":"GoogleAnalyticsLogo_lockupWrapper__m5ma5","linkWrapper":"GoogleAnalyticsLogo_linkWrapper__B-D8j"};